/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ApiRequestDto } from '../model/apiRequestDto';
import { ApiRequestDtoActiveControlledMedicationOptions } from '../model/apiRequestDtoActiveControlledMedicationOptions';
import { ApiRequestDtoBillingHistoryOptions } from '../model/apiRequestDtoBillingHistoryOptions';
import { ApiRequestDtoDiscontinuedControlledMedicationOptions } from '../model/apiRequestDtoDiscontinuedControlledMedicationOptions';
import { ApiRequestDtoListLiteralCategory } from '../model/apiRequestDtoListLiteralCategory';
import { ApiRequestDtoMedicalBenefitOrderOptions } from '../model/apiRequestDtoMedicalBenefitOrderOptions';
import { InvoiceGroup } from '../model/invoiceGroup';
import { LiteralCategory } from '../model/literalCategory';
import { MedDischargeOrder } from '../model/medDischargeOrder';
import { MedicalRecordOptions } from '../model/medicalRecordOptions';
import { NursingStation } from '../model/nursingStation';
import { Prescriber } from '../model/prescriber';
import { ReportResident } from '../model/reportResident';
import { SelectedMedList } from '../model/selectedMedList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ReportsService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets a Controlled Substance Disposal Log report for the specified log id
     * Sample Call  http://URL/api/Reports/GenerateControlledSubstanceDisposalReport?orgUnit&#x3D;ABING_RSCVA1&amp;amp;logId&#x3D;2eb289ec5f68411691c9d11bf59b141d
     * @param orgUnit 
     * @param logId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGenerateControlledSubstanceDisposalReport(orgUnit: string, logId: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGenerateControlledSubstanceDisposalReport(orgUnit: string, logId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGenerateControlledSubstanceDisposalReport(orgUnit: string, logId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGenerateControlledSubstanceDisposalReport(orgUnit: string, logId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling reportsGenerateControlledSubstanceDisposalReport.');
        }

        if (logId === null || logId === undefined) {
            throw new Error('Required parameter logId was null or undefined when calling reportsGenerateControlledSubstanceDisposalReport.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }
        if (logId !== undefined && logId !== null) {
            queryParameters = queryParameters.set('logId', <any>logId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post(`${this.basePath}/api/Reports/GenerateControlledSubstanceDisposalReport`,
            null,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Medication Return Log report for the provided log id
     * Sample Call  http://URL/api/Reports/GenerateMedicationReturnReport?orgUnit&#x3D;ABING_RSCVA1&amp;amp;logId&#x3D;1316d425071c4432954bb79953893ec3
     * @param orgUnit 
     * @param logId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGenerateMedicationReturnReport(orgUnit: string, logId: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGenerateMedicationReturnReport(orgUnit: string, logId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGenerateMedicationReturnReport(orgUnit: string, logId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGenerateMedicationReturnReport(orgUnit: string, logId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling reportsGenerateMedicationReturnReport.');
        }

        if (logId === null || logId === undefined) {
            throw new Error('Required parameter logId was null or undefined when calling reportsGenerateMedicationReturnReport.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }
        if (logId !== undefined && logId !== null) {
            queryParameters = queryParameters.set('logId', <any>logId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post(`${this.basePath}/api/Reports/GenerateMedicationReturnReport`,
            null,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Resident Allergy report for the selected facilities
     * Sample Call  http://URL/api/Reports/GenerateResidentAllergyReport
     * @param requestParameters Contains request parameters: orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGenerateResidentAllergyReport(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGenerateResidentAllergyReport(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGenerateResidentAllergyReport(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGenerateResidentAllergyReport(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGenerateResidentAllergyReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GenerateResidentAllergyReport`,
            requestParameters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Resident Literal Order report for the selected facilities
     * Sample Call  http://URL/api/Reports/GenerateResidentLiteralOrderReport?orgUnits&#x3D;100_WHS
     * @param requestParameters Contains request parameters: orgList, List&lt;LiteralCategory&gt;&lt;/LiteralCategory&gt;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGenerateResidentLiteralOrderReport(requestParameters: ApiRequestDtoListLiteralCategory, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGenerateResidentLiteralOrderReport(requestParameters: ApiRequestDtoListLiteralCategory, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGenerateResidentLiteralOrderReport(requestParameters: ApiRequestDtoListLiteralCategory, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGenerateResidentLiteralOrderReport(requestParameters: ApiRequestDtoListLiteralCategory, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGenerateResidentLiteralOrderReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GenerateResidentLiteralOrderReport`,
            requestParameters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generates an Active Controlled Medications report based on selected options
     * Sample Call  http://URL/api/Reports/GetActiveControlledMedicationsReport
     * @param requestParameters Contains request parameters: orgList, ActiveControlledMedicationOptions
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetActiveControlledMedicationsReport(requestParameters: ApiRequestDtoActiveControlledMedicationOptions, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetActiveControlledMedicationsReport(requestParameters: ApiRequestDtoActiveControlledMedicationOptions, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetActiveControlledMedicationsReport(requestParameters: ApiRequestDtoActiveControlledMedicationOptions, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetActiveControlledMedicationsReport(requestParameters: ApiRequestDtoActiveControlledMedicationOptions, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetActiveControlledMedicationsReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetActiveControlledMedicationsReport`,
            requestParameters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Manifest from DeliveryTrack
     * Sample Call  http://URL/api/Reports/GetManifestReport?reportDate&#x3D;2016-1-1T12:30:00&amp;amp;pharmId&#x3D;556_WHS&amp;amp;stopId&#x3D;1213&amp;amp;buId&#x3D;1001&amp;amp;ursId&#x3D;A5724716-E15F-46B7-9E87-4E2825F90217
     * @param reportDate 
     * @param orgUnit 
     * @param stopId 
     * @param buId 
     * @param ursId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetDeliveryTrackManifestReport(reportDate: string, orgUnit: string, stopId: string, buId: string, ursId: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetDeliveryTrackManifestReport(reportDate: string, orgUnit: string, stopId: string, buId: string, ursId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetDeliveryTrackManifestReport(reportDate: string, orgUnit: string, stopId: string, buId: string, ursId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetDeliveryTrackManifestReport(reportDate: string, orgUnit: string, stopId: string, buId: string, ursId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (reportDate === null || reportDate === undefined) {
            throw new Error('Required parameter reportDate was null or undefined when calling reportsGetDeliveryTrackManifestReport.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling reportsGetDeliveryTrackManifestReport.');
        }

        if (stopId === null || stopId === undefined) {
            throw new Error('Required parameter stopId was null or undefined when calling reportsGetDeliveryTrackManifestReport.');
        }

        if (buId === null || buId === undefined) {
            throw new Error('Required parameter buId was null or undefined when calling reportsGetDeliveryTrackManifestReport.');
        }

        if (ursId === null || ursId === undefined) {
            throw new Error('Required parameter ursId was null or undefined when calling reportsGetDeliveryTrackManifestReport.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (reportDate !== undefined && reportDate !== null) {
            queryParameters = queryParameters.set('reportDate', <any>reportDate);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }
        if (stopId !== undefined && stopId !== null) {
            queryParameters = queryParameters.set('stopId', <any>stopId);
        }
        if (buId !== undefined && buId !== null) {
            queryParameters = queryParameters.set('buId', <any>buId);
        }
        if (ursId !== undefined && ursId !== null) {
            queryParameters = queryParameters.set('ursId', <any>ursId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/api/Reports/GetManifestReport`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generates an Discontinued Controlled Medications report based on selected options
     * Sample Call  http://URL/api/Reports/GetDiscontinuedControlledMedicationsReport
     * @param requestParameters Contains request parameters: orgList, DiscontinuedControlledMedicationOptions
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetDiscontinuedControlledMedicationsReport(requestParameters: ApiRequestDtoDiscontinuedControlledMedicationOptions, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetDiscontinuedControlledMedicationsReport(requestParameters: ApiRequestDtoDiscontinuedControlledMedicationOptions, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetDiscontinuedControlledMedicationsReport(requestParameters: ApiRequestDtoDiscontinuedControlledMedicationOptions, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetDiscontinuedControlledMedicationsReport(requestParameters: ApiRequestDtoDiscontinuedControlledMedicationOptions, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetDiscontinuedControlledMedicationsReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetDiscontinuedControlledMedicationsReport`,
            requestParameters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Dispensed Controlled Medications Report
     * Sample Call  http://URL/api/Reports/GetDispensedControlledMedicationsReport
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetDispensedControlledMedicationsReport(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetDispensedControlledMedicationsReport(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetDispensedControlledMedicationsReport(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetDispensedControlledMedicationsReport(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetDispensedControlledMedicationsReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetDispensedControlledMedicationsReport`,
            requestParameters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Billing Detail Report
     * Sample Call  http://URL/api/Reports/GetGeneratedBillingDetailReport
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedBillingDetailReport(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedBillingDetailReport(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedBillingDetailReport(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedBillingDetailReport(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetGeneratedBillingDetailReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedBillingDetailReport`,
            requestParameters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generates a Billing History report based on selected options
     * Sample Call  http://URL/api/Reports/GetGeneratedBillingHistoryReport
     * @param requestParameters Contains request parameters: OrgList, RequestOptions as BillingHistoryOptions
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedBillingHistoryReport(requestParameters: ApiRequestDtoBillingHistoryOptions, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedBillingHistoryReport(requestParameters: ApiRequestDtoBillingHistoryOptions, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedBillingHistoryReport(requestParameters: ApiRequestDtoBillingHistoryOptions, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedBillingHistoryReport(requestParameters: ApiRequestDtoBillingHistoryOptions, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetGeneratedBillingHistoryReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedBillingHistoryReport`,
            requestParameters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Billing Summary Report
     * Sample Call  http://URL/api/Reports/GetGeneratedBillingSummaryReport?invoiceNumbers&#x3D;1
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param invoiceNumbers 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedBillingSummaryReport(requestParameters: ApiRequestDto, invoiceNumbers: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedBillingSummaryReport(requestParameters: ApiRequestDto, invoiceNumbers: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedBillingSummaryReport(requestParameters: ApiRequestDto, invoiceNumbers: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedBillingSummaryReport(requestParameters: ApiRequestDto, invoiceNumbers: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetGeneratedBillingSummaryReport.');
        }

        if (invoiceNumbers === null || invoiceNumbers === undefined) {
            throw new Error('Required parameter invoiceNumbers was null or undefined when calling reportsGetGeneratedBillingSummaryReport.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (invoiceNumbers !== undefined && invoiceNumbers !== null) {
            queryParameters = queryParameters.set('invoiceNumbers', <any>invoiceNumbers);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedBillingSummaryReport`,
            requestParameters,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Credit Detail report
     * Sample Call  http://URL/api/Reports/GetGeneratedCreditDetailReport
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedCreditDetailReport(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedCreditDetailReport(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedCreditDetailReport(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedCreditDetailReport(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetGeneratedCreditDetailReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedCreditDetailReport`,
            requestParameters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generates a LOA report based for the given resident
     * Sample Call  http://URL/api/Reports/GetGeneratedLOA
     * @param orgUnitId 
     * @param patientId 
     * @param printMonographs 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedLOA(orgUnitId: string, patientId: string, printMonographs: boolean, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedLOA(orgUnitId: string, patientId: string, printMonographs: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedLOA(orgUnitId: string, patientId: string, printMonographs: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedLOA(orgUnitId: string, patientId: string, printMonographs: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnitId === null || orgUnitId === undefined) {
            throw new Error('Required parameter orgUnitId was null or undefined when calling reportsGetGeneratedLOA.');
        }

        if (patientId === null || patientId === undefined) {
            throw new Error('Required parameter patientId was null or undefined when calling reportsGetGeneratedLOA.');
        }

        if (printMonographs === null || printMonographs === undefined) {
            throw new Error('Required parameter printMonographs was null or undefined when calling reportsGetGeneratedLOA.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnitId !== undefined && orgUnitId !== null) {
            queryParameters = queryParameters.set('orgUnitId', <any>orgUnitId);
        }
        if (patientId !== undefined && patientId !== null) {
            queryParameters = queryParameters.set('patientId', <any>patientId);
        }
        if (printMonographs !== undefined && printMonographs !== null) {
            queryParameters = queryParameters.set('printMonographs', <any>printMonographs);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedLOA`,
            null,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generates a MAR/TAR based on selected options
     * Sample Call  http://URL/api/Reports/GetGeneratedMarTar
     * @param options 
     * @param orgUnitId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedMarTar(options: MedicalRecordOptions, orgUnitId: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedMarTar(options: MedicalRecordOptions, orgUnitId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedMarTar(options: MedicalRecordOptions, orgUnitId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedMarTar(options: MedicalRecordOptions, orgUnitId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (options === null || options === undefined) {
            throw new Error('Required parameter options was null or undefined when calling reportsGetGeneratedMarTar.');
        }

        if (orgUnitId === null || orgUnitId === undefined) {
            throw new Error('Required parameter orgUnitId was null or undefined when calling reportsGetGeneratedMarTar.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnitId !== undefined && orgUnitId !== null) {
            queryParameters = queryParameters.set('orgUnitId', <any>orgUnitId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedMarTar`,
            options,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generates a MedSummary Discharge based on selected options
     * Sample Call  http://URL/api/Reports/GetGeneratedMedSummaryDischarge
     * @param patID 
     * @param orgUnitId 
     * @param extraRows 
     * @param printMonographs 
     * @param selectedRxs 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedMedDischarge(patID: string, orgUnitId: string, extraRows: number, printMonographs: boolean, selectedRxs: SelectedMedList, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedMedDischarge(patID: string, orgUnitId: string, extraRows: number, printMonographs: boolean, selectedRxs: SelectedMedList, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedMedDischarge(patID: string, orgUnitId: string, extraRows: number, printMonographs: boolean, selectedRxs: SelectedMedList, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedMedDischarge(patID: string, orgUnitId: string, extraRows: number, printMonographs: boolean, selectedRxs: SelectedMedList, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (patID === null || patID === undefined) {
            throw new Error('Required parameter patID was null or undefined when calling reportsGetGeneratedMedDischarge.');
        }

        if (orgUnitId === null || orgUnitId === undefined) {
            throw new Error('Required parameter orgUnitId was null or undefined when calling reportsGetGeneratedMedDischarge.');
        }

        if (extraRows === null || extraRows === undefined) {
            throw new Error('Required parameter extraRows was null or undefined when calling reportsGetGeneratedMedDischarge.');
        }

        if (printMonographs === null || printMonographs === undefined) {
            throw new Error('Required parameter printMonographs was null or undefined when calling reportsGetGeneratedMedDischarge.');
        }

        if (selectedRxs === null || selectedRxs === undefined) {
            throw new Error('Required parameter selectedRxs was null or undefined when calling reportsGetGeneratedMedDischarge.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (patID !== undefined && patID !== null) {
            queryParameters = queryParameters.set('patID', <any>patID);
        }
        if (orgUnitId !== undefined && orgUnitId !== null) {
            queryParameters = queryParameters.set('orgUnitId', <any>orgUnitId);
        }
        if (extraRows !== undefined && extraRows !== null) {
            queryParameters = queryParameters.set('extraRows', <any>extraRows);
        }
        if (printMonographs !== undefined && printMonographs !== null) {
            queryParameters = queryParameters.set('printMonographs', <any>printMonographs);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedMedSummaryDischarge`,
            selectedRxs,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generates a Med Fall Risk report for the selected org units
     * Sample Call  http://URL/api/Reports/GetGeneratedMedFallRisk
     * @param requestParameters Contains request parameters: orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedMedFallRiskReport(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedMedFallRiskReport(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedMedFallRiskReport(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedMedFallRiskReport(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetGeneratedMedFallRiskReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedMedFallRisk`,
            requestParameters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generates a Billing History report based on selected options
     * Sample Call  http://URL/api/Reports/GetGeneratedMedicalBenefitOrderReport
     * @param requestParameters Contains request parameters: orgList, MedicalBenefitOrderOptions
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedMedicalBenefitOrderReport(requestParameters: ApiRequestDtoMedicalBenefitOrderOptions, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedMedicalBenefitOrderReport(requestParameters: ApiRequestDtoMedicalBenefitOrderOptions, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedMedicalBenefitOrderReport(requestParameters: ApiRequestDtoMedicalBenefitOrderOptions, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedMedicalBenefitOrderReport(requestParameters: ApiRequestDtoMedicalBenefitOrderOptions, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetGeneratedMedicalBenefitOrderReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedMedicalBenefitOrderReport`,
            requestParameters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a New and Discontinued Orders Report
     * Sample Call  http://URL/api/Reports/GetGeneratedNewAndDiscontinuedOrdersReport
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedNewAndDiscontinuedOrdersReport(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedNewAndDiscontinuedOrdersReport(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedNewAndDiscontinuedOrdersReport(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedNewAndDiscontinuedOrdersReport(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetGeneratedNewAndDiscontinuedOrdersReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedNewAndDiscontinuedOrdersReport`,
            requestParameters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generates a POS report based on selected options
     * Sample Call  http://URL/api/Reports/GetGeneratedPos
     * @param options 
     * @param orgUnitId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedPos(options: MedicalRecordOptions, orgUnitId: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedPos(options: MedicalRecordOptions, orgUnitId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedPos(options: MedicalRecordOptions, orgUnitId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedPos(options: MedicalRecordOptions, orgUnitId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (options === null || options === undefined) {
            throw new Error('Required parameter options was null or undefined when calling reportsGetGeneratedPos.');
        }

        if (orgUnitId === null || orgUnitId === undefined) {
            throw new Error('Required parameter orgUnitId was null or undefined when calling reportsGetGeneratedPos.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnitId !== undefined && orgUnitId !== null) {
            queryParameters = queryParameters.set('orgUnitId', <any>orgUnitId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedPOS`,
            options,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param requestParameters 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedResidentDiagnosisReport(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedResidentDiagnosisReport(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedResidentDiagnosisReport(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedResidentDiagnosisReport(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetGeneratedResidentDiagnosisReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedResidentDiagnosisReport`,
            requestParameters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Routine Non-Usage Report
     * Sample Call  http://URL/api/Reports/GetGeneratedRoutineNonUsageReport?daysNotFilled&#x3D;1
     * @param requestParameters Contains request parameters: orgList
     * @param daysNotFilled 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedRoutineNonUsageReport(requestParameters: ApiRequestDto, daysNotFilled: number, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedRoutineNonUsageReport(requestParameters: ApiRequestDto, daysNotFilled: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedRoutineNonUsageReport(requestParameters: ApiRequestDto, daysNotFilled: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedRoutineNonUsageReport(requestParameters: ApiRequestDto, daysNotFilled: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetGeneratedRoutineNonUsageReport.');
        }

        if (daysNotFilled === null || daysNotFilled === undefined) {
            throw new Error('Required parameter daysNotFilled was null or undefined when calling reportsGetGeneratedRoutineNonUsageReport.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (daysNotFilled !== undefined && daysNotFilled !== null) {
            queryParameters = queryParameters.set('daysNotFilled', <any>daysNotFilled);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedRoutineNonUsageReport`,
            requestParameters,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets an Unbilled Charges Report
     * Sample Call  http://URL/api/Reports/GetGeneratedUnbilledChargesReport
     * @param requestParameters Contains request parameters: orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetGeneratedUnbilledChargesReport(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reportsGetGeneratedUnbilledChargesReport(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reportsGetGeneratedUnbilledChargesReport(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reportsGetGeneratedUnbilledChargesReport(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetGeneratedUnbilledChargesReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/Reports/GetGeneratedUnbilledChargesReport`,
            requestParameters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets Invoice Groups for the specified org units
     * Sample Call  http://URL/api/Reports/GetInvoiceGroups
     * @param requestParameters Contains request parameters: orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetInvoiceGroups(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<InvoiceGroup>>;
    public reportsGetInvoiceGroups(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InvoiceGroup>>>;
    public reportsGetInvoiceGroups(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InvoiceGroup>>>;
    public reportsGetInvoiceGroups(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetInvoiceGroups.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<InvoiceGroup>>(`${this.basePath}/api/Reports/GetInvoiceGroups`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets Literal Category for the specified org units
     * Sample Call  http://URL/api/Reports/GetLiteralCategories
     * @param requestParameters Contains request parameters: orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetLiteralCategories(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<LiteralCategory>>;
    public reportsGetLiteralCategories(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LiteralCategory>>>;
    public reportsGetLiteralCategories(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LiteralCategory>>>;
    public reportsGetLiteralCategories(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetLiteralCategories.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<LiteralCategory>>(`${this.basePath}/api/Reports/GetLiteralCategories`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns settings to populate a MAR/TAR Modal dialog for a specific facility
     * Sample Call  http://URL/api/Reports/GetMarTarOptions?orgUnit&#x3D;X
     * @param orgUnit 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetMarTarOptions(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<MedicalRecordOptions>;
    public reportsGetMarTarOptions(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicalRecordOptions>>;
    public reportsGetMarTarOptions(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicalRecordOptions>>;
    public reportsGetMarTarOptions(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling reportsGetMarTarOptions.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MedicalRecordOptions>(`${this.basePath}/api/Reports/GetMarTarOptions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Single Active resident List of Medication Orders
     * Sample Call  http://URL/api/Resident/GetMedOrders?orgUnit&#x3D;875&amp;amp;residentId&#x3D;185130
     * @param orgUnit Id of the Organizational Unit to return data for
     * @param residentId Id of the Resident to return data for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetMedOrders(orgUnit: string, residentId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MedDischargeOrder>>;
    public reportsGetMedOrders(orgUnit: string, residentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MedDischargeOrder>>>;
    public reportsGetMedOrders(orgUnit: string, residentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MedDischargeOrder>>>;
    public reportsGetMedOrders(orgUnit: string, residentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling reportsGetMedOrders.');
        }

        if (residentId === null || residentId === undefined) {
            throw new Error('Required parameter residentId was null or undefined when calling reportsGetMedOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }
        if (residentId !== undefined && residentId !== null) {
            queryParameters = queryParameters.set('residentId', <any>residentId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<MedDischargeOrder>>(`${this.basePath}/api/Reports/GetMedOrders`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets Nursing Stations for the specified org units
     * Sample Call  http://URL/api/Reports/GetNursingStations
     * @param requestParameters Contains request parameters: orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetNursingStations(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<NursingStation>>;
    public reportsGetNursingStations(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NursingStation>>>;
    public reportsGetNursingStations(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NursingStation>>>;
    public reportsGetNursingStations(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetNursingStations.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<NursingStation>>(`${this.basePath}/api/Reports/GetNursingStations`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns settings to populate a POS Modal dialog for a specific facility
     * Sample Call  http://URL/api/Reports/GetPosOptions?orgUnit&#x3D;X
     * @param orgUnit 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetPosOptions(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<MedicalRecordOptions>;
    public reportsGetPosOptions(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicalRecordOptions>>;
    public reportsGetPosOptions(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicalRecordOptions>>;
    public reportsGetPosOptions(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling reportsGetPosOptions.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MedicalRecordOptions>(`${this.basePath}/api/Reports/GetPosOptions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets Prescribers for the specified org units
     * Sample Call  http://URL/api/Reports/GetPrescribers
     * @param requestParameters Contains request parameters: orgList, nursingStations
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetPrescribers(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<Prescriber>>;
    public reportsGetPrescribers(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Prescriber>>>;
    public reportsGetPrescribers(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Prescriber>>>;
    public reportsGetPrescribers(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling reportsGetPrescribers.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<Prescriber>>(`${this.basePath}/api/Reports/GetPrescribers`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets Residents for the specified org unit
     * Sample Call  http://URL/api/Reports/GetResidents?orgUnit&#x3D;100_WHS
     * @param orgUnit 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportsGetResidentsForModal(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ReportResident>>;
    public reportsGetResidentsForModal(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReportResident>>>;
    public reportsGetResidentsForModal(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReportResident>>>;
    public reportsGetResidentsForModal(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling reportsGetResidentsForModal.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ReportResident>>(`${this.basePath}/api/Reports/GetResidents`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
